<template>
  <div class="titles_box">
    <div class="zh">{{zhName}}</div>
    <div class="en">{{enName}}</div>
    <img src="../assets/home/title_icon.png">
  </div>
</template>

<script>
export default {
  props: ['zhName','enName'],
  name: "titleNav"
}
</script>

<style scoped lang="less">
  .titles_box{
    text-align: center;
    cursor: pointer;
    .zh{
      font-size: 35px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 46px;
      color: #333333;
      margin-bottom: 5px;
    }
    .en{
      font-size: 50px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 66px;
      color: #333333;
      opacity: 0.1;
      margin-bottom: 30px;
    }
    img{
      width: 23px;
      height: 36px;
    }
  }
  @media (max-width: 1200px) {
    .titles_box{
      .zh{
        font-size: 18px;
        line-height: 21px;
        margin-bottom: 3px;
      }
      .en{
        font-size: 25px;
        line-height: 30px;
        margin-bottom: 14px;
      }
      img{
        width: 10px;
        height: 17px;
      }
    }
  }
</style>